<div class="rounded-lg border border-[#E9EAEE] p-4 {{ className() }}">
  <div class="collapsible-header flex items-center justify-between p-4" (click)="toggleCollapse()">
    <div class="flex items-center gap-2">
      <aux-icon
        [name]="isExpanded() ? 'ChevronUp' : 'ChevronDown'"
        class="text-aux-gray-darkest"
        [size]="20"
      />
      <div>
        <h3 class="text-lg font-semibold">{{ label() }}</h3>
        @if (subText()) {
          <p class="text-lg">{{ subText() }}</p>
        }
      </div>
    </div>
  </div>

  <div class="content-wrapper" [class.hidden]="!isExpanded()">
    <ng-content />
  </div>
</div>
